export const category = [
	{
		id: 1,
		categoryName: "Diabetes Care",
		categoryImage: "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/c2a0598f-483c-48ff-9783-71e402aa28d3.png",
	},
	{
		id: 2,
		categoryName: "Cardiac Care",
		categoryImage: "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/ab1da5f4-c074-47d2-b278-a5fbd2c93f1f.png",
	},
	{
		id: 3,
		categoryName: "Stomach Care",
		categoryImage: "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/702457a8-ff7d-43a6-bd1d-6bcb278ce686.png",
	},
	{
		id: 4,
		categoryName: "Born & Muscal Care",
		categoryImage: "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/ba975795-98dc-4cd8-8b55-3c20230d70e3.png",
	},
	{
		id: 5,
		categoryName: "Pain relief",
		categoryImage: "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/fa7ff8e9-f1f8-4a3e-9125-c9b36bcf38cd.png",
	},
	{
		id: 6,
		categoryName: "Liver Care",
		categoryImage: "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/995e64ba-5bd9-42bc-8db6-5dc0b821c89d.png",
	},
	{
		id: 7,
		categoryName: "Kidney Care",
		categoryImage: "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/e77d5099-d905-4462-ab9d-b51802e3739b.png",
	},
	{
		id: 8,
		categoryName: "Respitory Care",
		categoryImage: "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/4a788b46-97f3-460e-afb6-428368f779ee.png",
	},
	{
		id: 9,
		categoryName: "Eye Care",
		categoryImage: "https://onemg.gumlet.io/a_ignore,w_150,h_150,c_fit,q_auto,f_auto/631e3dca-3d5b-49f8-832b-8341ec4784e7.png",
	},
];
